/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type ClinicalReportDtoOrgansItem =
  (typeof ClinicalReportDtoOrgansItem)[keyof typeof ClinicalReportDtoOrgansItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClinicalReportDtoOrgansItem = {
  LUNG: 'LUNG',
  PLEURA: 'PLEURA',
  UROGENITAL: 'UROGENITAL',
  SPINE: 'SPINE',
  INTRATHORACIC_LYMPH_NODES: 'INTRATHORACIC_LYMPH_NODES',
  EXTRATHORACIC_LYMPH_NODES: 'EXTRATHORACIC_LYMPH_NODES',
  MENINGES: 'MENINGES',
  CNS_NON_MENINGEAL: 'CNS_NON_MENINGEAL',
  PERITONEUM_DIGECTIVE_TRACT: 'PERITONEUM_DIGECTIVE_TRACT',
  BONES_SKELETON_JOINTS: 'BONES_SKELETON_JOINTS',
  DISSEMINATED_FORM: 'DISSEMINATED_FORM',
  OTHER: 'OTHER',
} as const;
